import React, {useState, useEffect, useCallback, useRef} from 'react'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {useIntl} from 'react-intl'
import {getApplicationUser} from '../../../../../pages/applicationuser/list/core/_requests'
import {Model} from '../../../../../pages/applicationuser/list/core/_models'
import clsx from 'clsx'
import {getCountry as listCountry} from '../../../../../pages/country/list/core/_requests'
import {getCode as listGender} from '../../../../../pages/code/list/core/_requests'
import {getDiplomaAvarageType as listDiplomaAvarageType} from '../../../../../pages/diplomaavaragetype/list/core/_requests'
import {useDropzone} from 'react-dropzone'
import axios, {AxiosResponse} from 'axios'
import moment from 'moment'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert2'
import {useAuth} from '../../../../auth/core/Auth'
import * as EXIF from 'exif-js'
import {useLang} from '../../../../../../_metronic/i18n/Metronici18n'
import {Button, Form} from 'react-bootstrap'

const API_URL = process.env.REACT_APP_API_URL?.replace('/api', '/Files/')
const API_URL_REAL = process.env.REACT_APP_API_URL

const ProfileDetails: React.FC = () => {
  const intl = useIntl()
  const lang = useLang()
  const [data, setData] = useState<Model>()
  const [previewSrc, setPreviewSrc] = useState('') // Add this state to keep track of the preview URL
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [diplomaavaragetypes, setdiplomaavaragetypes] = React.useState([])
  const [loading, setLoading] = useState(false)
  const [countrys, setcountrys] = React.useState([])
  const [genders, setgenders] = React.useState([])
  const [isImageUplouded, setIsImageUplouded] = React.useState(false)
  const navigate = useNavigate()
  const {logout, currentUser, setCurrentUser} = useAuth()

  const profileDetailsSchema = Yup.object().shape({
    name: Yup.string()
      .required(intl.formatMessage({id: 'First_name_is_required'}))
      .nullable(),
    surname: Yup.string()
      .required(intl.formatMessage({id: 'Last_name_is_required'}))
      .nullable(),
    mothersName: Yup.string()
      .required(intl.formatMessage({id: 'Mother name is required'}))
      .nullable(),
    fathersName: Yup.string()
      .required(intl.formatMessage({id: 'Father name is required'}))
      .nullable(),
    passportNumber: Yup.string()
      .required(intl.formatMessage({id: 'Passoport num is required'}))
      .nullable(),
    birthDate: Yup.string()
      .required(intl.formatMessage({id: 'Birthday is required'}))
      .nullable(),
    birthPlace: Yup.string()
      .required(intl.formatMessage({id: 'BirthPlace is required'}))
      .nullable(),
    address: Yup.string()
      .required(intl.formatMessage({id: 'Adress is required'}))
      .nullable(),
    phone: Yup.string()
      .required(intl.formatMessage({id: 'Phone is required'}))
      .matches(
        /^((?!\+?90|90)\d*)$/,
        intl.formatMessage({id: 'Phone must not start with +90 or 90'})
      )
      .length(11, intl.formatMessage({id: 'Phone must be exactly 11 digits'}))
      .nullable(),
    highSchoolName: Yup.string()
      .required(intl.formatMessage({id: 'highSchoolName is required'}))
      .nullable(),
    highSchoolStartDate: Yup.string()
      .required(intl.formatMessage({id: 'highSchoolStartDate is required'}))
      .nullable(),
    highSchoolFinishDate: Yup.string()
      .required(intl.formatMessage({id: 'highSchoolEndDate is required'}))
      .nullable(),
    countryId: Yup.number()
      .required(intl.formatMessage({id: 'countryId is required'}))
      .nullable(),
    genderId: Yup.number()
      .required(intl.formatMessage({id: 'gender is required'}))
      .nullable(),
    highSchoolCountryId: Yup.number()
      .required(intl.formatMessage({id: 'highSchoolCountryId is required'}))
      .nullable(),
  })

  const fileSelectedHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const fileExtension = event?.target?.files[0].name.split('.').pop()?.toLowerCase()

      if (fileExtension !== 'jpg') {
        swal.fire({
          title: intl.formatMessage({
            id: 'Error',
          }),
          text: intl.formatMessage({id: 'Swal_Wrong_Format_jpg'}),
          icon: 'error',
          confirmButtonText: intl.formatMessage({id: 'Okay'}),
        })
        return
      }
      setSelectedFile(event.target.files[0])
    }
  }

  const fileUploadHandler = async () => {
    if (selectedFile) {
      const formData = new FormData()
      formData.append('file', selectedFile, selectedFile.name)

      await axios.post(`${API_URL_REAL}/Custom/uploadid`, formData).then(async (response) => {
        navigate('/exam/otherexams')
      })
    }
  }
  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    const file = acceptedFiles[0]
    const fileExtension = file?.name.split('.').pop()?.toLowerCase()
    if (fileExtension !== 'jpg' || !file) {
      swal.fire({
        title: intl.formatMessage({
          id: 'Error',
        }),
        text: intl.formatMessage({id: 'Swal_Wrong_Format_jpg'}),
        icon: 'error',
        confirmButtonText: intl.formatMessage({id: 'Okay'}),
      })
      return
    }

    const reader = new FileReader()

    reader.onload = async function (e) {
      const img = new Image()
      img.src = e.target?.result as string

      img.onload = async function () {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        EXIF.getData(img, async function () {
          const orientation = EXIF.getTag(img, 'Orientation')
          let width = img.width
          let height = img.height

          if (orientation === 6 || orientation === 8) {
            canvas.width = height
            canvas.height = width
          } else {
            canvas.width = width
            canvas.height = height
          }

          if (ctx) {
            switch (orientation) {
              case 2:
                ctx.transform(-1, 0, 0, 1, width, 0)
                break
              case 3:
                ctx.transform(-1, 0, 0, -1, width, height)
                break
              case 4:
                ctx.transform(1, 0, 0, -1, 0, height)
                break
              case 5:
                ctx.transform(0, 1, 1, 0, 0, 0)
                break
              case 6:
                ctx.transform(0, 1, -1, 0, height, 0)
                break
              case 7:
                ctx.transform(0, -1, -1, 0, height, width)
                break
              case 8:
                ctx.transform(0, -1, 1, 0, 0, width)
                break
              default:
                ctx.transform(1, 0, 0, 1, 0, 0)
            }

            ctx.drawImage(img, 0, 0)

            canvas.toBlob(async function (blob) {
              const formData = new FormData()
              formData.append('avatar', blob as Blob, file.name)

              try {
                const response = await axios.post(`${API_URL_REAL}/Custom/UploadAvatar`, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                })

                const dats = response.data
                const url =
                  dats?.id !== null
                    ? (API_URL || '') + ('avatar_' + dats?.id || '') + ('.jpg?ver=' + rasgeleSayi())
                    : '/media/avatars/blank.png'

                setPreviewSrc(url)
                setIsImageUplouded(true)
              } catch (error) {
                console.error('Error uploading image:', error)
              }
            })
          }
        })
      }
    }

    reader.readAsDataURL(file)
  }, [])

  useEffect(() => {
    if (currentUser?.trYosTransactionDone === '0') navigate('/exam/tryos')
    else if (currentUser?.idUploaded === '1') {
      navigate('/exam/otherexams')
    }
  }, [])

  useEffect(() => {
    getApplicationUser(
      'isonlyuserrecords=true',
      'Id,Name,Surname,Email,BirthDate,BirthPlace,HighSchoolName,HighSchoolCountryId,HighSchoolStartDate,HighSchoolFinishDate,DiplomaAvarage,DiplomaAvarageTypeId,Phone,Address,PassportNumber,PhotoFileName,EmailConfirmed,MothersName,FathersName,CountryId,Country.Name as Country,GenderId,Gender.Name as Gender',
      'Country,Gender'
    ).then((res: any) => {
      setData(res.data[0])
      formik.setValues({
        ...formik.values,
        ...res.data[0],
      })
      const url =
        res.data[0]?.id !== null
          ? (API_URL || '') + ('avatar_' + res.data[0]?.id || '') + ('.jpg?ver=' + rasgeleSayi())
          : '/media/avatars/blank.png'

      setPreviewSrc(url)
    })

    listCountry('sort=Name&items_per_page=9999', 'Id,Name,NameEn').then((res: any) => {
      setcountrys(res.data || [])
    })

    listGender('filter_TypeString=cinsiyet', 'Id,Name,NameEn').then((res: any) => {
      setgenders(res.data || [])
    })

    listDiplomaAvarageType('sort=Name&items_per_page=9999', 'Id,Name,MaxPoints,Increasing').then(
      (res: any) => {
        setdiplomaavaragetypes(res.data || [])
      }
    )
  }, [])

  function rasgeleSayi() {
    let min = 100000 // En küçük 6 basamaklı sayı
    let max = 999999 // En büyük 6 basamaklı sayı
    let rasgele = Math.floor(Math.random() * (max - min + 1)) + min
    return rasgele.toString()
  }

  const formik = useFormik<Model>({
    initialValues: {
      name: undefined,
      surname: undefined,
      email: undefined,
      password: undefined,
      mothersName: undefined,
      fathersName: undefined,
      countryId: undefined,
      genderId: undefined,
      passportNumber: undefined,
      birthDate: new Date(),
      birthPlace: undefined,
      address: undefined,
      phone: undefined,
      diplomaAvarage: undefined,
      diplomaAvarageTypeId: undefined,
      highSchoolName: undefined,
      highSchoolCountryId: undefined,
      highSchoolStartDate: undefined,
      highSchoolFinishDate: undefined,
    },
    validationSchema: profileDetailsSchema,

    onSubmit: async (values) => {
      values.country = undefined
      values.gender = undefined

      setLoading(true)
      try {
        if (!isImageUplouded) {
          swal
            .fire({
              title: intl.formatMessage({
                id: 'Error',
              }),
              text: intl.formatMessage({id: 'You_have_to_upload_Foto'}),
              icon: 'error',
              confirmButtonText: intl.formatMessage({id: 'Okay'}),
            })
            .then((result) => {})
          return
        }

        if (currentUser?.idApproved !== '1' && selectedFile === null) {
          swal
            .fire({
              title: intl.formatMessage({
                id: 'Error',
              }),
              text: intl.formatMessage({id: 'You have to upload your id document to proceed.'}),
              icon: 'error',
              confirmButtonText: intl.formatMessage({id: 'Okay'}),
            })
            .then((result) => {})
          return
        }

        const isError = diplomaavaragetypes.some((a: any) => {
          if (values.diplomaAvarage !== undefined && a.id === values.diplomaAvarageTypeId) {
            return values.diplomaAvarage < a.minPoints || values.diplomaAvarage > a.maxPoints
          }
        })

        //return;

        if (isError) {
          swal
            .fire({
              title: intl.formatMessage({
                id: 'Error',
              }),
              text: intl.formatMessage({
                id: 'Wrong diploma average. Please provide an avarage according to the type you have selected.',
              }),
              icon: 'error',
              confirmButtonText: intl.formatMessage({id: 'Okay'}),
            })
            .then((result) => {})
          return
        }

        try {
          const response = await axios.put(`${API_URL_REAL}/Auth/UpdateApplicationUser`, values)

          // Update local state with updated user data
          setData(response.data)

          if (selectedFile !== null) {
            await fileUploadHandler().then(async (res: any) => {
              await updateIdUploaded('1')
            })
          } else {
            swal
              .fire({
                title: intl.formatMessage({
                  id: 'Success',
                }),
                text: intl.formatMessage({id: 'Kaydınız başarıyla tamamlandı.'}),
                icon: 'success',
                confirmButtonText: intl.formatMessage({id: 'Okay'}),
              })
              .then((result) => {
                if (result.isConfirmed) {
                  navigate('/crafted/account/overview')
                }
              })
          }
        } catch (error: any) {
          if (error.response && error.response.data && error.response.data.message) {
            swal.close()
            const errorMessage = error.response.data.message
            swal.fire({
              title: intl.formatMessage({id: 'Error'}),
              text: intl.formatMessage({id: errorMessage}),
              icon: 'error',
              confirmButtonText: intl.formatMessage({id: 'Okay'}),
            })
          } else {
            swal.close()
            swal.fire({
              title: intl.formatMessage({id: 'Error'}),
              text: intl.formatMessage({id: 'Beklenmedik_Hata'}),
              icon: 'error',
              confirmButtonText: intl.formatMessage({id: 'Okay'}),
            })
          }
        }
      } catch (error) {
        console.error('Failed to update user data: ', error)
      } finally {
        setLoading(false)
      }
    },
  })

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    accept: {
      'image/jpg': ['.jpg'],
    }, // accept only JPEG images
    multiple: false, // accept only one file
  })

  const updateIdUploaded = async (newValue: string) => {
    return new Promise<void>((resolve, reject) => {
      if (currentUser?.id === undefined) {
        reject('User ID is undefined.')
        return
      }

      const updatedUser = {
        ...currentUser,
        idUploaded: newValue,
      }

      setCurrentUser(updatedUser)
      resolve()
    })
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>{intl.formatMessage({id: 'Profile Details'})}</h3>
        </div>
      </div>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='alert alert-danger'>{intl.formatMessage({id: 'PhotoWarning'})}</div>
            <div className='row mb-6 mb-10'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Photograph'})} (JPG)
              </label>
              <div className='col-lg-8 '>
                <div
                  className='image-input image-input-outline'
                  data-kt-image-input='true'
                  style={{
                    backgroundImage: `url(${toAbsoluteUrl('/media/avatars/blank.png')})`,
                    marginLeft: '20px',
                  }}
                >
                  <div
                    className='image-input-wrapper w-125px h-175px'
                    style={{
                      backgroundImage: `url(${previewSrc})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }}
                  ></div>
                </div>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <button type='button' className='btn btn-primary mt-2'>
                    {intl.formatMessage({id: 'Upload New Picture'})}
                  </button>
                </div>
              </div>
            </div>
            {/* {
                            currentUser?.idApproved !== "1" ?
                                (
                                    <>
                                        {currentUser?.idApproved === "0" ?
                                            (
                                                <div className='alert alert-danger'>
                                                    {currentUser?.rejectionReason}
                                                </div>
                                            )
                                            :
                                            (
                                                <div className='alert alert-danger'>
                                                    {intl.formatMessage({ id: 'Please upload your passport photo. If you do not have a passport, please upload the other required documents.' })}
                                                </div>
                                            )
                                        }
                                        <div className='row mb-10'>
                                            <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                                                {intl.formatMessage({ id: 'Identity Document' })} (JPG)
                                            </label>
                                            <div className='col-lg-8 fv-row d-flex align-items-center'>
                                                <input type="file" accept={".jpg"} onChange={fileSelectedHandler} />
                                            </div>
                                        </div>
                                    </>
                                )
                                :
                                <></>
                        } */}
            <div className='row mb-10'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Identity Document'})} (JPG)
              </label>
              <div className='col-lg-8 fv-row d-flex align-items-center'>
                <input type='file' accept={'.jpg'} onChange={fileSelectedHandler} />
              </div>
            </div>

            <div className='alert alert-danger'>{intl.formatMessage({id: 'NameWarning'})}</div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Name'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('name')}
                  type='text'
                  name='name'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.name && formik.errors.name},
                    {
                      'is-valid': formik.touched.name && !formik.errors.name,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.name && formik.errors.name && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.name}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Surname'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('surname')}
                  type='text'
                  name='surname'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.surname && formik.errors.surname},
                    {
                      'is-valid': formik.touched.surname && !formik.errors.surname,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.surname && formik.errors.surname && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.surname}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'MothersName'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('mothersName')}
                  type='text'
                  name='mothersName'
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.mothersName && formik.errors.mothersName},
                    {
                      'is-valid': formik.touched.mothersName && !formik.errors.mothersName,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.mothersName && formik.errors.mothersName && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.mothersName}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'FathersName'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('fathersName')}
                  type='text'
                  name='fathersName'
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.fathersName && formik.errors.fathersName},
                    {
                      'is-valid': formik.touched.fathersName && !formik.errors.fathersName,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.fathersName && formik.errors.fathersName && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.fathersName}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'BirthDate'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('birthDate')}
                  type='date'
                  name='birthDate'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.birthDate && formik.errors.birthDate},
                    {
                      'is-valid': formik.touched.birthDate && !formik.errors.birthDate,
                    }
                  )}
                  autoComplete='off'
                  value={moment(formik.values.birthDate).format('YYYY-MM-DD')}
                  onChange={(e) => {
                    // formik.setFieldValue('birthDate', new Date(e.target.value).toISOString())
                    const selectedDate = e.target.value
                    formik.setFieldValue(
                      'birthDate',
                      selectedDate ? new Date(selectedDate).toISOString() : null
                    )
                  }}
                />
                {formik.touched.birthDate && formik.errors.birthDate && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.birthDate}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'BirthPlace'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('birthPlace')}
                  type='text'
                  name='birthPlace'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.birthPlace && formik.errors.birthPlace},
                    {
                      'is-valid': formik.touched.birthPlace && !formik.errors.birthPlace,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.birthPlace && formik.errors.birthPlace && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.birthPlace}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'PassportNumber'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('passportNumber')}
                  type='text'
                  name='passportNumber'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.passportNumber && formik.errors.passportNumber},
                    {
                      'is-valid': formik.touched.passportNumber && !formik.errors.passportNumber,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.passportNumber && formik.errors.passportNumber && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.passportNumber}</div>
                  </div>
                )}
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Email'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('email')}
                  type='text'
                  name='email'
                  disabled
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.email && formik.errors.email},
                    {
                      'is-valid': formik.touched.email && !formik.errors.email,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.email && formik.errors.email && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.email}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Phone'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('phone')}
                  type='text'
                  name='phone'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.phone && formik.errors.phone},
                    {
                      'is-valid': formik.touched.phone && !formik.errors.phone,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.phone && formik.errors.phone && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.phone}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Address'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('address')}
                  type='text'
                  name='address'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {'is-invalid': formik.touched.address && formik.errors.address},
                    {
                      'is-valid': formik.touched.address && !formik.errors.address,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.address && formik.errors.address && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.address}</div>
                  </div>
                )}
              </div>
            </div>
            {/* 
                        <div className='row mb-6'>
                            <label className='col-lg-4 col-form-label fw-bold fs-6'>{intl.formatMessage({ id: 'Change Password' })}</label>

                            <div className='col-lg-8 fv-row'>
                                <input
                                    {...formik.getFieldProps('password')}
                                    type='password'
                                    name='password'
                                    className={clsx(
                                        'form-control form-control-lg form-control-solid',
                                        { 'is-invalid': formik.touched.password && formik.errors.password },
                                        {
                                            'is-valid': formik.touched.password && !formik.errors.password,
                                        }
                                    )}
                                    autoComplete='off'
                                />
                                {formik.touched.password && formik.errors.password && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>{formik.errors.password}</div>
                                    </div>
                                )}
                            </div>
                        </div> */}

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Nationality'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  {...formik.getFieldProps('countryId')}
                  value={formik.values.countryId}
                >
                  <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
                  {countrys.map((myval: any) => (
                    <option value={myval?.id} key={myval?.id as any}>
                      {lang === 'tr' ? (myval?.name as any) : (myval?.nameEn as any)}
                    </option>
                  ))}
                </select>
                {formik.touched.countryId && formik.errors.countryId && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.countryId}</div>
                  </div>
                )}
                <div className='alert alert-danger mt-5'>
                  {intl.formatMessage({id: 'nationalityWarning'})}
                </div>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'Gender'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  {...formik.getFieldProps('genderId')}
                  value={formik.values.genderId}
                >
                  <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
                  {genders.map((myval: any) => (
                    <option value={myval?.id} key={myval?.id as any}>
                      {lang === 'tr' ? (myval?.name as any) : (myval?.nameEn as any)}
                    </option>
                  ))}
                </select>
                {formik.touched.genderId && formik.errors.genderId && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.genderId}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'HighSchoolName'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('highSchoolName')}
                  type='text'
                  name='highSchoolName'
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.highSchoolName && formik.errors.highSchoolName},
                    {
                      'is-valid': formik.touched.highSchoolName && !formik.errors.highSchoolName,
                    }
                  )}
                  autoComplete='off'
                />
                {formik.touched.highSchoolName && formik.errors.highSchoolName && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.highSchoolName}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'HighSchoolStartDate'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('highSchoolStartDate')}
                  type='date'
                  name='highSchoolStartDate'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {
                      'is-invalid':
                        formik.touched.highSchoolStartDate && formik.errors.highSchoolStartDate,
                    },
                    {
                      'is-valid':
                        formik.touched.highSchoolStartDate && !formik.errors.highSchoolStartDate,
                    }
                  )}
                  autoComplete='off'
                  value={moment(formik.values.highSchoolStartDate).format('YYYY-MM-DD')}
                  onChange={(e) => {
                    // formik.setFieldValue('highSchoolStartDate', new Date(e.target.value).toISOString())
                    const selectedDate = e.target.value
                    formik.setFieldValue(
                      'highSchoolStartDate',
                      selectedDate ? new Date(selectedDate).toISOString() : null
                    )
                  }}
                />
                {formik.touched.highSchoolStartDate && formik.errors.highSchoolStartDate && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.highSchoolStartDate}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'HighSchoolFinishDate'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  {...formik.getFieldProps('highSchoolFinishDate')}
                  type='date'
                  name='highSchoolFinishDate'
                  className={clsx(
                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0',
                    {
                      'is-invalid':
                        formik.touched.highSchoolFinishDate && formik.errors.highSchoolFinishDate,
                    },
                    {
                      'is-valid':
                        formik.touched.highSchoolFinishDate && !formik.errors.highSchoolFinishDate,
                    }
                  )}
                  autoComplete='off'
                  value={moment(formik.values.highSchoolFinishDate).format('YYYY-MM-DD')}
                  onChange={(e) => {
                    // formik.setFieldValue('highSchoolFinishDate', new Date(e.target.value).toISOString())
                    const selectedDate = e.target.value
                    formik.setFieldValue(
                      'highSchoolFinishDate',
                      selectedDate ? new Date(selectedDate).toISOString() : null
                    )
                  }}
                />
                {formik.touched.highSchoolFinishDate && formik.errors.highSchoolFinishDate && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.highSchoolFinishDate}</div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {intl.formatMessage({id: 'HighSchoolCountry'})}
              </label>

              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  {...formik.getFieldProps('highSchoolCountryId')}
                  value={formik.values.highSchoolCountryId}
                >
                  <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
                  {countrys.map((myval: any) => (
                    <option value={myval?.id} key={myval?.id as any}>
                      {lang === 'tr' ? (myval?.name as any) : (myval?.nameEn as any)}
                    </option>
                  ))}
                </select>
                {formik.touched.highSchoolCountryId && formik.errors.highSchoolCountryId && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.highSchoolCountryId}</div>
                  </div>
                )}
              </div>
            </div>

            {/* <div className='row mb-6'>
                            <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                                {intl.formatMessage({ id: 'DiplomaAvarageType' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                                <select
                                    className='form-select form-select-solid form-select-md'
                                    {...formik.getFieldProps('diplomaAvarageTypeId')}
                                    value={formik.values.diplomaAvarageTypeId}
                                >
                                    <option value=''>{intl.formatMessage({ id: 'SEÇİNİZ' })}</option>
                                    {diplomaavaragetypes.map((myval: any) => (
                                        <option value={myval?.id} key={myval?.id as any}>
                                            {myval?.name as any}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className='row mb-6'>
                            <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                                {intl.formatMessage({ id: 'DiplomaAvarage' })}
                            </label>
                            <div className='col-lg-8 fv-row'>
                                <input
                                    {...formik.getFieldProps('diplomaAvarage')}
                                    type='number'
                                    name='diplomaAvarage'
                                    className={clsx(
                                        'form-control form-control-solid mb-3 mb-lg-0',
                                        { 'is-invalid': formik.touched.diplomaAvarage && formik.errors.diplomaAvarage },
                                        {
                                            'is-valid': formik.touched.diplomaAvarage && !formik.errors.diplomaAvarage,
                                        }
                                    )}
                                    autoComplete='off'
                                />
                                {formik.touched.diplomaAvarage && formik.errors.diplomaAvarage && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span role='alert'>{formik.errors.diplomaAvarage}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div> */}
            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <button
                type='button'
                className='btn btn-primary'
                disabled={loading}
                onClick={formik.submitForm}
              >
                {!loading && intl.formatMessage({id: 'Save Changes'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'Please_wait'})}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <Button variant='danger' onClick={logout} disabled={loading}>
                {intl.formatMessage({id: 'Logout'})}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {ProfileDetails}
